import {
  GET_MENU,
  GET_MENU_SUCCESS,
  GET_MENU_FAILURE,
  GET_BADGE_MENU,
  GET_BADGE_MENU_SUCCESS,
  GET_BADGE_MENU_FAILURE,
} from "./actionTypes";

export const getMenu = () => ({
  type: GET_MENU,
});

export const getMenuSuccess = (data) => ({
  type: GET_MENU_SUCCESS,
  payload: data,
});

export const getMenuFailure = () => ({
  type: GET_MENU_FAILURE,
});

export const getBadgeMenu = () => ({
  type: GET_BADGE_MENU,
});

export const getBadgeMenuSuccess = (data) => ({
  type: GET_BADGE_MENU_SUCCESS,
  payload: data,
});

export const getBadgeMenuFailure = () => ({
  type: GET_BADGE_MENU_FAILURE,
});
